var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('layout-header'),_c('router-view'),_c('layout-rooter'),_c('div',{staticClass:"to-top",staticStyle:{"display":"none"},on:{"click":_vm.toTop}},[_vm._v("TOP")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }